<script setup>
import { computed } from 'vue';
const props = defineProps({
  maxItem: Object, // {item_details: {title, value, agent: {name, avatar_url}, created_at, stage, status}}
  minItem: Object, // idem
  title: String,
});

function formatDate(dateStr) {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  return d.toLocaleDateString('pt-BR');
}
</script>

<template>
  <div>
    <h3 class="font-semibold text-base mb-2">{{ title }}</h3>
    <div class="flex flex-col md:flex-row gap-4">
      <div
        v-if="maxItem"
        class="flex-1 flex items-center gap-2 border-2 border-green-400 dark:border-green-600 rounded-lg px-3 py-2 bg-green-50 dark:bg-green-900 text-xs text-slate-700 dark:text-slate-200 shadow"
        :title="`Título: ${maxItem.item_details?.title}\nValor: ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parseFloat(maxItem.item_details?.value) || 0)}\nData: ${formatDate(maxItem.item_details?.created_at)}\nEstágio: ${maxItem.item_details?.stage || '-'}\nStatus: ${maxItem.item_details?.status || '-'}\nAgente: ${maxItem.agent ? maxItem.agent.name : 'Sem agente'}`"
      >
        <span class="font-semibold bg-green-400 text-white rounded px-2 py-0.5 mr-1">Maior</span>
        <span class="font-semibold">Título: {{ maxItem.item_details?.title }}</span>
        <span>|</span>
        <span>{{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parseFloat(maxItem.item_details?.value) || 0) }}</span>
        <span>|</span>
        <span>Data: {{ formatDate(maxItem.item_details?.created_at) }}</span>
        <span>|</span>
        <span>Estágio: {{ maxItem.item_details?.stage || '-' }}</span>
        <span>|</span>
        <span>Status: {{ maxItem.item_details?.status || '-' }}</span>
        <span v-if="maxItem.agent">|</span>
        <span v-if="maxItem.agent">
          Agente:
          <img :src="maxItem.agent.avatar_url" :alt="maxItem.agent.name" class="w-5 h-5 rounded-full inline-block" />
          {{ maxItem.agent.name }}
        </span>
        <span v-else class="italic text-slate-400">| Sem agente</span>
      </div>
      <div
        v-if="minItem"
        class="flex-1 flex items-center gap-2 border-2 border-blue-400 dark:border-blue-600 rounded-lg px-3 py-2 bg-blue-50 dark:bg-blue-900 text-xs text-slate-700 dark:text-slate-200 shadow"
        :title="`Título: ${minItem.item_details?.title}\nValor: ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parseFloat(minItem.item_details?.value) || 0)}\nData: ${formatDate(minItem.item_details?.created_at)}\nEstágio: ${minItem.item_details?.stage || '-'}\nStatus: ${minItem.item_details?.status || '-'}\nAgente: ${minItem.agent ? minItem.agent.name : 'Sem agente'}`"
      >
        <span class="font-semibold bg-blue-400 text-white rounded px-2 py-0.5 mr-1">Menor</span>
        <span class="font-semibold">Título: {{ minItem.item_details?.title }}</span>
        <span>|</span>
        <span>{{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parseFloat(minItem.item_details?.value) || 0) }}</span>
        <span>|</span>
        <span>Data: {{ formatDate(minItem.item_details?.created_at) }}</span>
        <span>|</span>
        <span>Estágio: {{ minItem.item_details?.stage || '-' }}</span>
        <span>|</span>
        <span>Status: {{ minItem.item_details?.status || '-' }}</span>
        <span v-if="minItem.agent">|</span>
        <span v-if="minItem.agent">
          Agente:
          <img :src="minItem.agent.avatar_url" :alt="minItem.agent.name" class="w-5 h-5 rounded-full inline-block" />
          {{ minItem.agent.name }}
        </span>
        <span v-else class="italic text-slate-400">| Sem agente</span>
      </div>
    </div>
  </div>
</template> 